<itl-text-input-template
  [control]="ngControl?.control"
  [icon]="icon"
  [title]="title"
  [value]="ngControl?.value"
  [maxlength]="maxlength"
  [description]="description"
  [noIcon]="noIcon"
  [disabled]="disabled"
  [required]="required"
  (focusClicked)="setFocus()"
>
  <input
    #input
    class="alb-input"
    [ngClass]="{
      bold: ngControl?.value && ngControl?.value.length,
      'alb-input--disabled': disabled,
    }"
    type="text"
    inputmode="decimal"
    [placeholder]="placeholder"
    [attr.maxlength]="maxlength"
    [disabled]="disabled"
    [readonly]="disabled"
    (focus)="markAsTouched()"
    (input)="onInput($event)"
    (blur)="onTouched()"
  />
</itl-text-input-template>
